import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function Hero() {
  return <section className="relative pt-28 pb-16 lg:pt-36 lg:pb-24 overflow-hidden w-full bg-background" data-id="element-78">
      <div className="max-w-7xl mx-auto px-6" data-id="element-79">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center" data-id="element-80">
          {/* Left Column: Text Content & Mobile Image */}
          <div className="flex flex-col" data-id="element-81">
            <motion.h1 initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.8,
            ease: 'easeOut'
          }} className="text-4xl sm:text-5xl lg:text-6xl font-semibold tracking-tight text-primary leading-[1.15]" data-id="element-82">
              Адвокати у справах ТЦК, ВЛК та мобілізації. <br data-id="element-83" />
              <span className="text-secondary" data-id="element-84">
                Захищаємо, коли система помиляється.
              </span>
            </motion.h1>

            {/* Mobile Image (Visible only on small screens, between Headline and Description) */}
            <motion.div initial={{
            opacity: 0,
            scale: 0.95
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            duration: 1,
            ease: 'easeOut',
            delay: 0.2
          }} className="block lg:hidden w-full h-[300px] sm:h-[380px] rounded-[2rem] overflow-hidden shadow-xl my-7" data-id="element-85">
              <img src="https://cdn.magicpatterns.com/uploads/dg2C1TUqC2PdVDxuWnhxvk/zilvinas-ka-ZuIlvGEO8_I-unsplash.jpg" alt="Ukrainian Military" className="w-full h-full object-cover" data-id="element-86" />
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.8,
            ease: 'easeOut',
            delay: 0.3
          }} className="mt-7 lg:mt-8" data-id="element-87">
              <div className="flex flex-col sm:flex-row items-center gap-4" data-id="element-88">
                <a href="#contact" className="w-full sm:w-auto px-8 py-3.5 bg-primary text-background rounded-full font-medium flex items-center justify-center gap-2 hover:opacity-90 transition-opacity shadow-lg" data-id="element-89">
                  Безкоштовна консультація
                  <ArrowRight size={18} data-id="element-90" />
                </a>
                <a href="#services" className="w-full sm:w-auto px-8 py-3.5 bg-surface text-primary rounded-full font-medium hover:bg-border/50 transition-colors border border-border" data-id="element-91">
                  Наші послуги
                </a>
              </div>
            </motion.div>
          </div>

          {/* Right Column: Desktop Image (Visible only on large screens) */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          x: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          x: 0
        }} transition={{
          duration: 1,
          ease: 'easeOut',
          delay: 0.2
        }} className="hidden lg:block w-full h-[500px] rounded-[2.5rem] overflow-hidden shadow-2xl" data-id="element-92">
            <img src="https://cdn.magicpatterns.com/uploads/dg2C1TUqC2PdVDxuWnhxvk/zilvinas-ka-ZuIlvGEO8_I-unsplash.jpg" alt="Ukrainian Military" className="w-full h-full object-cover hover:scale-105 transition-transform duration-1000" data-id="element-93" />
          </motion.div>
        </div>
      </div>
    </section>;
}